import { render, staticRenderFns } from "./PatentOwnerList.vue?vue&type=template&id=1b141ff9&"
import script from "./PatentOwnerList.vue?vue&type=script&lang=js&"
export * from "./PatentOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./PatentOwnerList.vue?vue&type=style&index=0&id=1b141ff9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports